var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "google-button",
      attrs: { type: "button", disabled: _vm.disabled },
      on: { click: _vm.clickButton },
    },
    [
      _c("span", { staticClass: "google-button__icon" }, [_c("GoogleIcon")], 1),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "google-button__text" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }